import { render, staticRenderFns } from "./HoldingGeneralInfoItem.vue?vue&type=template&id=696d9004&scoped=true&"
import script from "./HoldingGeneralInfoItem.vue?vue&type=script&lang=js&"
export * from "./HoldingGeneralInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./HoldingGeneralInfoItem.vue?vue&type=style&index=0&id=696d9004&prod&scoped=true&lang=css&"
import style1 from "./HoldingGeneralInfoItem.vue?vue&type=style&index=1&id=696d9004&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696d9004",
  null
  
)

export default component.exports